import api from '../../../../api/client';


export const leaveApplyApi = {
  async getList(params = {}) {
    try {
      const response = await api.get('/self-service/leave-apply/', { params });
      return {
        data: response.data.items || [],
        total: response.data.total_count || (response.data.items || []).length,
      };
    } catch (err) {
      console.warn('Failed to fetch leave applications from server:', err);
      return { data: [], total: 0 };
    }
  },

  async getById(id) {
    try {
      const response = await api.get(`/self-service/leave-apply/${id}`);
      return { data: response.data };
    } catch (err) {
      console.warn(`Failed to fetch leave application #${id}:`, err);
      return { data: null };
    }
  },

  async getBalances() {
    try {
      const response = await api.get('/self-service/leave-balance/');
      return { data: response.data.items || [] };
    } catch (err) {
      console.warn('Failed to fetch leave balances from server:', err);
      return { data: [] };
    }
  },

  async getTypes() {
    try {
      const response = await api.get('/self-service/leave-apply/types');
      return { data: response.data || [] };
    } catch (err) {
      console.warn('Failed to fetch leave types from server:', err);
      return { data: [] };
    }
  },

  async getReasons() {
    try {
      const response = await api.get('/self-service/leave-apply/reasons');
      return { data: response.data || [] };
    } catch (err) {
      console.warn('Failed to fetch leave reasons from server:', err);
      return { data: [] };
    }
  },

  async create(data) {
    const payload = {
      EmpId: data.EmpId || data.empId || 1,
      LeaveTypeID: data.LeaveTypeID || data.leaveTypeId || 1,
      LeaveDate: data.LeaveDate || data.fromDate || data.leaveDate || new Date().toISOString().split('T')[0],
      DrCr: 'D',
      Quantity: Number(data.Quantity || data.days || 1.0),
      ReasonId: Number(data.ReasonId || data.reasonId || 1),
      Remarks: data.Remarks || data.remarks || '',
      ApplyDate: data.ApplyDate || data.applyDate || new Date().toISOString().split('T')[0],
      DaysType: data.type === 'HalfDay' ? 0.5 : 0.0,
      IsApproved: 0,
      name: data.name,
      employeeId: data.employeeId || data.empId,
      fromDate: data.fromDate,
      tillDate: data.tillDate,
      leaveType: data.leaveType,
      reason: data.reason,
      days: data.days,
      type: data.type,
      status: 'Pending',
    };
    const response = await api.post('/self-service/leave-apply/', payload);
    return { data: response.data.data, message: response.data.message || 'Leave application submitted' };
  },

  async update(id, data) {
    const payload = {
      EmpId: data.EmpId || data.empId,
      LeaveTypeID: data.LeaveTypeID || data.leaveTypeId,
      LeaveDate: data.LeaveDate || data.fromDate || data.leaveDate,
      DrCr: 'D',
      Quantity: Number(data.Quantity || data.days || 1.0),
      ReasonId: Number(data.ReasonId || data.reasonId || 0),
      Remarks: data.Remarks || data.remarks,
      ApplyDate: data.ApplyDate || data.applyDate,
      DaysType: data.type === 'HalfDay' ? 0.5 : 0.0,
      name: data.name,
      employeeId: data.employeeId || data.empId,
      fromDate: data.fromDate,
      tillDate: data.tillDate,
      leaveType: data.leaveType,
      reason: data.reason,
      days: data.days,
      type: data.type,
      status: data.status,
    };
    const response = await api.put(`/self-service/leave-apply/${id}`, payload);
    return { data: response.data.data, message: response.data.message || 'Leave application updated' };
  },

  async approve(id, isApproved) {
    const response = await api.post(`/self-service/leave-apply/${id}/approve`, {
      is_approved: isApproved ? 1 : 2,
    });
    return { data: response.data, message: response.data.message };
  },

  async delete(id) {
    const response = await api.delete(`/self-service/leave-apply/${id}`);
    return { success: response.data.success, message: response.data.message };
  },
};
